module.exports = __webpack_public_path__ + "static/img/login_bg.3cd036a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bbc54yyk/login_bg.jpg
// module id = 932
// module chunks = 30